import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../app/hooks";
import { useParams } from "react-router";
import { schoolSlice, selectSchool } from "../../../redux/school/schoolSlice";
import PageAuthenticatedLoading from "../../../features/pages/PageAuthenticatedLoading";
import { imageInsSlice } from "../../../redux/image/imageInsSlice";
import { ElementUploadImage } from "../../../features/base/image/ElementUploadImage";
import ElementSkeleton from "../../../features/base/ElementSkeleton";
import ClassroomPageTitle from "../basics/ClassroomPageTitle";
import ClassroomPageAvatar from "../basics/ClassroomPageAvatar";
import { classroomSlice, selectClassroom } from "../../../redux/classroom/classroomSlice";
import { routeClassroom } from "../../../routes/classroom";
import { ElementMissingContext } from "../../../features/base/ElementMissingContext";
import { ObjectTarget } from "../../../app/permissions";
import { assertThumbnailUrl } from "../../../redux/common";
import { TopBar } from "../../../features/top/TopBar";

export function ClassroomImage() {
    const school = useSelector(selectSchool);
    const classroom = useSelector(selectClassroom);
    const dispatch = useAppDispatch();

    const {schoolId, classroomId} = useParams();
    console.debug(`SchoolImage: ${schoolId}, Classroom: ${classroomId}`);
    if(!schoolId || !classroomId) {
        return <ElementMissingContext />;
    }

    const breadcrumbTitle = "Alterar Imagem";
  
    const breadcrumbs = [ { label: breadcrumbTitle }, ];

    const title = <ClassroomPageTitle schoolId={schoolId} classroomId={classroomId} />;
    const pageAvatar = <ClassroomPageAvatar />;
  
    const buildContent = () =>
        (classroom.selected)
        ? <ElementUploadImage 
              currentImage={assertThumbnailUrl(classroom.selected.url)}
              name={classroom.selected.name}
              backTo={routeClassroom(schoolId, classroomId, "images")}
              target={{schoolId: schoolId, avatar: true, objectTarget: ObjectTarget.CLASSROOM, targetId: classroomId}}
              backCleanup={() => {
                dispatch(schoolSlice.actions.clean());
                dispatch(classroomSlice.actions.clean());
                dispatch(imageInsSlice.actions.clean());
              }}
          />
        : <ElementSkeleton />
      ;

    return <PageAuthenticatedLoading key="classroomImage"
        topbar={ <TopBar title={title} pageAvatar={pageAvatar} breadcrumbs={breadcrumbs} /> }
        loading={{
            states: [school.state, classroom.state], 
            content: buildContent,
            error: "Erro ao carregar sala de aula",
            retry: () => {
            dispatch(schoolSlice.actions.clean());
            },
        }}
    />;
                
}
